import { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import MainLayout from "../../layouts/MainLayout";
import NewsModalPdf from "./NewsModalPdf";


const NewsPage = () => {
  const { translations } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);

      const onClose = () => { 
        setIsOpen(false)
  }


  return (
    <MainLayout>

      <div className="py-5 bg-white mt-20 container m-auto">
        <img src='/assets/Pictures/newsHeader-06.jpg' className="mx-auto max-w-[800px] w-full" />
        <div className="w-full text-center">

          <button className='bg-[#d60530] rounded-xl p-2 px-3 text-sm text-white mx-auto my-3' onClick={() => setIsOpen(true)} >
            {translations.Hiervormerkenlassen}
          </button>
        </div>
        <img src='/assets/Pictures/newsHeader-06-02.jpg' className="mx-auto max-w-[800px] w-full" />
        <img src='/assets/Pictures/newsHeader-06-03.jpg' className="mx-auto max-w-[800px] w-full" />
        <img src='/assets/Pictures/newsHeader-06-04.jpg' className="mx-auto max-w-[800px] w-full" />
        <img src='/assets/Pictures/newsHeader-06-05.jpg' className="mx-auto max-w-[800px] w-full" />
        <img src='/assets/Pictures/newsHeader-06-06.jpg' className="mx-auto max-w-[800px] w-full" />
      </div>
      <NewsModalPdf isOpen={isOpen} onClose={onClose} />
    </MainLayout>
  );
};

export default NewsPage;
